'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modal = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _events = require('events');

require('./index.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalManagement = function (_EventEmitter) {
  _inherits(ModalManagement, _EventEmitter);

  function ModalManagement() {
    _classCallCheck(this, ModalManagement);

    var _this = _possibleConstructorReturn(this, (ModalManagement.__proto__ || Object.getPrototypeOf(ModalManagement)).call(this));

    _this.dom = null;

    _this.open = _this.open.bind(_this);
    _this.close = _this.close.bind(_this);
    return _this;
  }

  _createClass(ModalManagement, [{
    key: 'open',
    value: function open(dom, callback) {
      if (typeof callback === 'function') callback();
      this.dom = dom;
      this.emitChange();
    }
  }, {
    key: 'close',
    value: function close(callback) {
      if (typeof callback === 'function') callback();
      this.dom = null;
      this.emitChange();
    }
  }, {
    key: 'emitChange',
    value: function emitChange() {
      this.emit('modal', this.dom);
    }
  }]);

  return ModalManagement;
}(_events.EventEmitter);

var modal = exports.modal = new ModalManagement();

var ModalComponent = function (_Component) {
  _inherits(ModalComponent, _Component);

  function ModalComponent() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, ModalComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = ModalComponent.__proto__ || Object.getPrototypeOf(ModalComponent)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      dom: null
    }, _this2.handleModal = function (dom) {
      _this2.setState({ dom: dom });
    }, _this2.hendleKeyClose = function (e) {
      if (e.code !== 'Escape') return;
      modal.close();
    }, _this2.hendleClickClose = function (e) {
      if (e.target !== e.currentTarget) return;
      modal.close();
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(ModalComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      modal.addListener('modal', this.handleModal);
      window.addEventListener('keydown', this.hendleKeyClose);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      modal.removeListener('modal', this.handleModal);
      window.removeEventListener('keydown', this.hendleKeyClose);
    }
  }, {
    key: 'render',
    value: function render() {
      var dom = this.state.dom;

      return !!dom && _react2.default.createElement(
        'div',
        { className: 'react-modal-backdrop', onClick: this.hendleClickClose },
        _react2.default.createElement(
          'div',
          { className: 'react-modal-scroll', onClick: this.hendleClickClose },
          dom
        )
      );
    }
  }]);

  return ModalComponent;
}(_react.Component);

exports.default = ModalComponent;